import { Card } from '@nextui-org/react';
import Draggable from 'react-draggable';
import styled from 'styled-components';

import { CloseIcon, DraggableIcon } from '../../../assets';
import ZIndexLayers from '../../../services/ZIndexLayers';
import { ThemeProp } from '../../../theme/Themes';

interface StyledCardProps {
  $isDragging: boolean;
}

export const StyledDraggable = styled(Draggable)`
  z-index: ${ZIndexLayers.popup};
`;

export const StyledCard = styled(Card)<StyledCardProps>`
  transition: ${({ $isDragging }: StyledCardProps) => ($isDragging ? 'none' : null)};
  padding: 1rem 0;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }: ThemeProp) => theme.colors.greyscale.c800};
  box-shadow: 0px 1rem 2rem 0px rgba(91, 48, 112, 0.08); // NOTE: Design specification.
  z-index: ${ZIndexLayers.popup};
  gap: 1rem;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  cursor: move; // Fallback
  cursor: grab;
  padding: 0 1rem;

  &:active {
    cursor: grabbing;
  }
`;

export const CardBody = styled.div``;

export const HeaderContentContainer = styled.div``;

export const HeaderSpacer = styled.div`
  flex-grow: 1;
`;

export const DraggableIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledCloseIcon = styled(CloseIcon)`
  stroke: ${(props: ThemeProp) => props.theme.colors.greyscale.c100};
  transform: translate(0.25rem, -0.25rem);
  cursor: pointer;
`;

export const StyledDraggableIcon = styled(DraggableIcon)`
  margin-right: 0.5rem;
  stroke: ${({ theme }: ThemeProp) => theme.colors.greyscale.c600};
`;
